import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { http } from "../../lib/api";
import { BUCKETS, bucketCls, fmt, pct, Kpi } from "../../lib/lm";
import { Pill } from "../kit/Kit";
import { LoanFicha } from "./LoanFicha";

const STATUS = ["Vigente", "Vencido", "Castigado", "Liquidado", "Prepagado", "Reestructurado", "Refinanciado"];

export const LoanTable = ({ ds }) => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [bk, setBk] = useState("");
  const [st, setSt] = useState("");
  const [sel, setSel] = useState(null);
  useEffect(() => { http.get("/lm/loans", { params: { dataset: ds } }).then((r) => setRows(r.data)); }, [ds]);
  const f = useMemo(() => (rows || []).filter((r) => (!q || `${r.loan_id} ${r.borrower_id}`.toLowerCase().includes(q.toLowerCase())) && (!bk || r.bucket === bk) && (!st || r.status === st)), [rows, q, bk, st]);
  const saldo = f.reduce((a, r) => a + (r.saldo || 0), 0);
  if (!rows) return <p className="text-sm text-[#8C867A]">Cargando cartera…</p>;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Kpi l="Créditos" v={f.length} testid="lm-kpi-creditos" />
        <Kpi l="Saldo insoluto" v={fmt(saldo)} testid="lm-kpi-saldo" />
        <Kpi l="Monto original" v={fmt(f.reduce((a, r) => a + (r.monto || 0), 0))} testid="lm-kpi-original" />
        <Kpi l="Con atraso" v={f.filter((r) => r.dpd > 0).length} testid="lm-kpi-atraso" />
      </div>
      <div className="flex flex-wrap gap-2">
        <label className="flex flex-1 items-center gap-2 rounded-xl border border-[#E2DDD5] bg-white px-3"><Search size={15} className="text-[#8C867A]" />
          <input data-testid="lm-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar crédito o acreditado" className="w-full py-2 text-sm outline-none" /></label>
        <select data-testid="lm-filter-bucket" value={bk} onChange={(e) => setBk(e.target.value)} className="rounded-xl border border-[#E2DDD5] bg-white px-3 text-sm"><option value="">Todos los buckets</option>{BUCKETS.map((b) => <option key={b}>{b}</option>)}</select>
        <select data-testid="lm-filter-status" value={st} onChange={(e) => setSt(e.target.value)} className="rounded-xl border border-[#E2DDD5] bg-white px-3 text-sm"><option value="">Todos los estatus</option>{STATUS.map((b) => <option key={b}>{b}</option>)}</select>
      </div>
      <div className="overflow-x-auto rounded-2xl border border-[#E2DDD5] bg-white">
        <table className="w-full text-sm" data-testid="lm-table">
          <thead className="bg-[#FAF8F5] text-left text-[10px] uppercase tracking-widest text-[#8C867A]">
            <tr>{["Crédito", "Acreditado", "Producto", "Desembolso", "Monto", "Saldo", "DPD", "Bucket", "Estatus", "Etapa", "Datos"].map((h) => <th key={h} className="px-3 py-3">{h}</th>)}</tr></thead>
          <tbody>{f.map((r) => (
            <tr key={r.loan_id} data-testid={`lm-row-${r.loan_id}`} onClick={() => setSel(r.loan_id)} className="cursor-pointer border-t border-[#F2F0EC] transition-colors hover:bg-[#FDF0EB]">
              <td className="px-3 py-2.5 font-semibold">{r.loan_id}</td><td className="px-3">{r.borrower_id}</td><td className="px-3">{r.producto || "Sin dato"}</td>
              <td className="px-3 tabular-nums">{r.desembolso}</td><td className="px-3 text-right tabular-nums">{fmt(r.monto)}</td><td className="px-3 text-right tabular-nums">{fmt(r.saldo)}</td>
              <td className="px-3 text-right tabular-nums">{r.dpd}</td><td className="px-3"><Pill cls={bucketCls(r.bucket)}>{r.bucket}</Pill></td><td className="px-3">{r.status}</td>
              <td className="px-3">{r.etapa}</td><td className="px-3 tabular-nums">{pct(r.completitud, 0)}</td></tr>))}</tbody>
        </table>
      </div>
      {sel && <LoanFicha ds={ds} id={sel} onClose={() => setSel(null)} />}
    </div>
  );
};
